module.exports = __webpack_public_path__ + "img/supply-chain.f7e4682b.png";